import React, { FC } from "react";
import cx from "classnames";

import { Footer } from "~/components/common/Footer/Footer";

import "./AppLayout.scss";

export type AppLayoutSize = "sm" | "md" | "lg" | "xl";

export type AppLayoutProps = {
  name?: string;
  size?: AppLayoutSize;
};

export const AppLayout: FC<AppLayoutProps> = ({ children, size = "md" }) => {
  return (
    <div className="app-wrapper w-100 d-flex flex-column justify-content-between">
      <div className="d-flex justify-content-center py-4 px-4">
        <div className={cx("app-layout", size)}>{children}</div>
      </div>
      <Footer />
    </div>
  );
};
